import React from "react";
import { Typography } from "@material-ui/core";
import { FuseAnimate } from "@fuse";
import { Link } from "react-router-dom";
import queryString from "query-string";
import { ReplaceAll } from "app/Core/Helpers";

const ErrorPage = () => {
    const { search } = document.location;
    const AQueryParsed = queryString.parse(search);
    return (
        <div className="flex flex-col flex-1 items-center justify-center p-16">
            <div className="max-w-512 text-center">
                <FuseAnimate delay={500}>
                    <Typography variant="h5" color="textSecondary" className="mb-16">
                        Ops, ocorreu um erro inesperado. Por favor entre em contato com o administrador do sistema para relatar os passos que levaram a este problema para solucionarmos o mais breve possível. Obrigado.
                    </Typography>
                </FuseAnimate>
                <Typography variant="" color="textSecondary" className="mb-16 hidden">
                    {ReplaceAll(AQueryParsed.q, "_", " ")}
                </Typography>
                <Link className="font-medium" to="/pub-login">Voltar ao início</Link>
            </div>
        </div>
    );
};

export default ErrorPage;